export const GET_CANCEL_DELETE_ACCOUNT_ATTEMPT = 'GET_CANCEL_DELETE_ACCOUNT_ATTEMPT';
export const GET_CANCEL_DELETE_ACCOUNT_SUCCESS = 'GET_CANCEL_DELETE_ACCOUNT_SUCCESS';
export const GET_CANCEL_DELETE_ACCOUNT_FAILURE = 'GET_CANCEL_DELETE_ACCOUNT_FAILURE';
export const CLEAR_STATE = 'CLEAR_STATE';
